// extracted by mini-css-extract-plugin
module.exports = {"basePriceNameInput":"UpsellDowngradeList_basePriceNameInput__2TzL3"};